import { useEffect } from 'react';
import { createStore, createHook } from 'react-sweet-state';
import { getCodeFeatureState } from '../../services/code-feature';
import { useCodeLocalStore } from '../code-local-store';
import { setFeatureState } from './actions';
import { type State, type FeatureState, codeFeatureStates } from './types';

const actions = {
	setFeatureState,
} as const;

type Actions = typeof actions;

const initialState: State = {
	state: codeFeatureStates.LOADING,
};

// @Export for testing
export const Store = createStore<State, Actions>({
	name: 'codePageFeatureStateStore',
	initialState,
	actions,
});

const useCodeFeatureHook = createHook(Store);

export const useCodeFeatureState = (): FeatureState => {
	const [
		{
			projectContext: { projectId },
		},
	] = useCodeLocalStore();
	const [featureState, featureActions] = useCodeFeatureHook();

	useEffect(() => {
		const fetchData = async () => {
			const isEnabled = await getCodeFeatureState(projectId);
			featureActions.setFeatureState(isEnabled);
		};
		// We need to check projectId because of the default state
		if (projectId > 0) {
			fetchData();
		}
	}, [featureActions, projectId]);

	return featureState.state;
};
